<template lang="pug">
v-container(fluid pa-0 ma-0)
  v-row
    v-col
      v-toolbar(
        id="core-toolbar"
        flat
        dense
        :max-height="$vuetify.breakpoint.mobile ? '100px' : '70px'"
        class="tw-mb-0"
        style="background: #f5f5fa !important"
      )
        div(class="v-toolbar-title")
          v-toolbar-title(class=" tertiary--text font-weight-light")
            v-btn(v-if="responsive" class="default v-btn--simple" dark icon @click.stop="onClickBtn")
              v-icon mdi-view-list
        div
          span(class=" tw-capitalize tw-text-3xl tw-font-bold text-secondary ") {{ $t('Common.' + title) }}
        v-spacer
        core-search-bar(v-if="!$vuetify.breakpoint.mobile")
        v-toolbar-items
          v-flex(align-center layout py-2)
            v-menu(
              bottom
              left
              content-class="dropdown-menu"
              offset-y
              transition="slide-y-transition"
              :open-on-hover="true"
            )
              template(v-slot:activator="{ on, attrs }")
                div(v-ripple class="toolbar-items" v-bind="attrs" v-on="on" to="/inbox")
                  v-badge(color="error" :content="notifications.length" overlap)
                    v-icon mdi-bell
              v-list(dense)
                v-list-item(v-for="(notification, i) in notifications" :key="i" @click="onClick")
                  v-list-item-title {{ notification }}
            router-link(to="/user" v-ripple class="toolbar-items")
              v-icon mdi-account
    v-row(v-if="$vuetify.breakpoint.mobile" no-gutters class="w-100")
      v-col(cols="12")
        core-search-bar(class=" mt-n12 pr-2 pl-1")
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  data: () => ({
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      "You're now a friend with Andrew",
      'Another Notification',
      'Another One',
    ],
    title: null,
    responsive: false,
    responsiveInput: false,
  }),

  watch: {
    $route(val) {
      this.title = val.meta.section;
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
  },
};
</script>
<style lang="scss">
#core-toolbar a {
  text-decoration: none;
}

.v-toolbar__content {
  margin-left: 10px !important;
}
</style>
